import { _ as _defineProperty } from '../defineProperty-377d5a7f.js';
import { PICSART_HOST_URL } from '../configs/constants/index.js';

var countryData = /*#__PURE__*/function (countryData) {
  countryData["US"] = "US";
  countryData["AM"] = "AM";
  return countryData;
}({});

var navigationItems = {
  allPhotoEditorLandings: {
    label: 'See All',
    url: "".concat(PICSART_HOST_URL, "/photo-editing-tools/"),
    strong: true
  },
  allVideoEditorLandings: {
    label: 'See All',
    url: "".concat(PICSART_HOST_URL, "/video-editing-tools/"),
    strong: true
  },
  promoVideos: {
    label: 'Promo Videos',
    url: "".concat(PICSART_HOST_URL, "/promo-videos/")
  },
  posterTemplates: {
    label: 'Poster Templates',
    url: "".concat(PICSART_HOST_URL, "/design-templates/poster/")
  },
  editingTools: {
    label: 'Editing Tools',
    url: "".concat(PICSART_HOST_URL, "/editing-tools/"),
    pjax: true,
    dataTest: 'editing-tools-hypertext'
  },
  photoEditor: {
    label: 'Photo Editor',
    url: "".concat(PICSART_HOST_URL, "/photo-editor/"),
    subCategory: 'photo_editor',
    category: 'products'
  },
  videoEditor: {
    label: 'Video Editor',
    url: "".concat(PICSART_HOST_URL, "/video-editor/"),
    subCategory: 'video_editor',
    category: 'products'
  },
  collageMaker: {
    label: 'Collage Maker',
    url: "".concat(PICSART_HOST_URL, "/collage-maker/")
  },
  addStickersToPhotos: {
    label: 'Add Stickers to Photos',
    url: "".concat(PICSART_HOST_URL, "/add-stickers-to-photos/")
  },
  stickerMaker: {
    label: 'Sticker Maker',
    url: "".concat(PICSART_HOST_URL, "/sticker-maker/")
  },
  apps: {
    label: 'Mobile Apps',
    url: "".concat(PICSART_HOST_URL, "/apps/"),
    pjax: true,
    category: 'products'
  },
  challenges: {
    label: 'Challenges',
    url: "".concat(PICSART_HOST_URL, "/challenges/")
  },
  aboutUs: {
    label: 'About us',
    url: "".concat(PICSART_HOST_URL, "/about-us/"),
    pjax: true,
    dataTest: 'about-us-hypertext'
  },
  pressKit: {
    label: 'Press Center',
    url: "".concat(PICSART_HOST_URL, "/press-kit/"),
    pjax: true
  },
  career: {
    label: 'Careers',
    url: "".concat(PICSART_HOST_URL, "/jobs/")
  },
  support: {
    label: 'Support',
    url: 'https://support.picsart.com/hc/en-us/'
  },
  images: {
    label: 'Images',
    url: "".concat(PICSART_HOST_URL, "/images/"),
    pjax: true,
    subCategory: 'images',
    category: 'discover'
  },
  stickers: {
    label: 'Stickers',
    url: "".concat(PICSART_HOST_URL, "/stickers/"),
    pjax: true,
    subCategory: 'stickers',
    category: 'discover'
  },
  gifs: {
    label: 'Gifs',
    url: "".concat(PICSART_HOST_URL, "/hashtag/gif/popular-gifs/"),
    pjax: true
  },
  hashtags: {
    label: 'Hashtags',
    url: "".concat(PICSART_HOST_URL, "/hashtags/"),
    pjax: true,
    subCategory: 'hashtags',
    category: 'discover'
  },
  backgrounds: {
    label: 'Backgrounds',
    url: "".concat(PICSART_HOST_URL, "/hashtag/background/"),
    pjax: true
  },
  blog: {
    label: 'Blog',
    url: "".concat(PICSART_HOST_URL, "/blog/")
  },
  tutorials: {
    label: 'Tutorials',
    url: "".concat(PICSART_HOST_URL, "/blog/category/design-school/"),
    category: 'learn'
  },
  tc: {
    label: 'Terms of Use',
    url: "".concat(PICSART_HOST_URL, "/terms-of-use/"),
    dataTest: 'terms-of-use-hypertext',
    withCountryCode: true
  },
  communityGuidelines: {
    label: 'Community Guidelines',
    url: "".concat(PICSART_HOST_URL, "/community-guidelines/"),
    dataTest: 'community-hypertexts'
  },
  securityPolicy: {
    label: 'Security Policy',
    url: "".concat(PICSART_HOST_URL, "/security-policy/")
  },
  privacy: {
    label: 'Privacy Policy',
    url: "".concat(PICSART_HOST_URL, "/privacy-policy/"),
    withCountryCode: true
  },
  interestBasedAds: {
    label: 'Interest-Based Advertising',
    url: "".concat(PICSART_HOST_URL, "/privacy-policy#interest-based")
  },
  DMCA: {
    label: 'DMCA',
    url: "".concat(PICSART_HOST_URL, "/copyright-dispute-policy/")
  },
  ethyca: {
    label: 'Do Not Sell',
    localisedLabels: _defineProperty({}, countryData.US, 'Do Not Sell or Share My Personal Information'),
    url: 'https://privacy.picsart.com/dont_sell/'
  },
  memeGenerator: {
    label: 'Meme Generator',
    url: "".concat(PICSART_HOST_URL, "/meme-generator/")
  },
  textEditor: {
    label: 'Text Editor',
    url: "".concat(PICSART_HOST_URL, "/text-editor/")
  },
  backgroundChanger: {
    label: 'Background Changer',
    url: "".concat(PICSART_HOST_URL, "/background-changer/")
  },
  backgroundRemover: {
    label: 'Background Remover',
    url: "".concat(PICSART_HOST_URL, "/background-remover/")
  },
  photoEffects: {
    label: 'Photo Effects',
    url: "".concat(PICSART_HOST_URL, "/photo-effects/")
  },
  sketchEffects: {
    label: 'Sketch Effects',
    url: "".concat(PICSART_HOST_URL, "/photo-effects/sketch/")
  },
  doubleExposure: {
    label: 'Double Exposure',
    url: "".concat(PICSART_HOST_URL, "/photo-effects/double-exposure/")
  },
  imageUpscale: {
    label: 'Image Upscale',
    url: "".concat(PICSART_HOST_URL, "/image-upscale/")
  },
  changeSky: {
    label: 'Change Sky',
    url: "".concat(PICSART_HOST_URL, "/change-sky/")
  },
  imageOverlays: {
    label: 'Image Overlays',
    url: "".concat(PICSART_HOST_URL, "/image-overlays/")
  },
  animals: {
    label: 'Animals',
    url: "".concat(PICSART_HOST_URL, "/images/animals/"),
    pjax: true
  },
  editing: {
    label: 'Editing Styles',
    url: "".concat(PICSART_HOST_URL, "/images/editing-styles/"),
    pjax: true
  },
  fashion: {
    label: 'Fashion & Beauty',
    url: "".concat(PICSART_HOST_URL, "/images/fashion-and-beauty/"),
    pjax: true
  },
  foodAndDrink: {
    label: 'Food & Drink',
    url: "".concat(PICSART_HOST_URL, "/images/food-and-drink/"),
    pjax: true
  },
  popularAndTrends: {
    label: 'Popular & Trends',
    url: "".concat(PICSART_HOST_URL, "/images/popular-and-trends/"),
    pjax: true
  },
  nature: {
    label: 'Nature',
    url: "".concat(PICSART_HOST_URL, "/images/nature/"),
    pjax: true
  },
  stickersAnime: {
    label: 'Anime',
    url: "".concat(PICSART_HOST_URL, "/stickers/anime/"),
    pjax: true
  },
  stickersHolidaysAndEvents: {
    label: 'Holidays & Events',
    url: "".concat(PICSART_HOST_URL, "/stickers/holidays-and-events/"),
    pjax: true
  },
  stickersColors: {
    label: 'Colors',
    url: "".concat(PICSART_HOST_URL, "/stickers/colors/"),
    pjax: true
  },
  stickersEmoji: {
    label: 'Emoji',
    url: "".concat(PICSART_HOST_URL, "/stickers/emoji/"),
    pjax: true
  },
  stickersMeme: {
    label: 'Meme',
    url: "".concat(PICSART_HOST_URL, "/stickers/meme/"),
    pjax: true
  },
  stickersLove: {
    label: 'Love',
    url: "".concat(PICSART_HOST_URL, "/stickers/love/"),
    pjax: true
  },
  hashtagsBackgrounds: {
    label: 'Backgrounds',
    url: "".concat(PICSART_HOST_URL, "/hashtag/backgrounds/"),
    pjax: true
  },
  hashtagsTravel: {
    label: 'Travel',
    url: "".concat(PICSART_HOST_URL, "/hashtag/travel/"),
    pjax: true
  },
  hashtagsFood: {
    label: 'Food',
    url: "".concat(PICSART_HOST_URL, "/hashtag/food/"),
    pjax: true
  },
  hashtagsFashion: {
    label: 'Fashion',
    url: "".concat(PICSART_HOST_URL, "/hashtag/fashion/"),
    pjax: true
  },
  hashtagsLove: {
    label: 'Love',
    url: "".concat(PICSART_HOST_URL, "/hashtag/love/"),
    pjax: true
  },
  hashtagsSelfie: {
    label: 'Selfie',
    url: "".concat(PICSART_HOST_URL, "/hashtag/selfie/"),
    pjax: true
  },
  slideShowMaker: {
    label: 'Slideshow Maker',
    url: "".concat(PICSART_HOST_URL, "/slideshow-maker/")
  },
  mobileApps: {
    label: 'Mobile Apps',
    url: "".concat(PICSART_HOST_URL, "/apps/"),
    pjax: true,
    category: 'products'
  },
  feed: {
    onlySignedIn: true,
    label: 'Feed',
    url: "".concat(PICSART_HOST_URL, "/feed/")
  },
  explore: {
    label: 'Explore',
    url: "".concat(PICSART_HOST_URL, "/explore/"),
    pjax: true,
    category: 'discover'
  },
  artists: {
    label: 'Artists',
    url: "".concat(PICSART_HOST_URL, "/tags-artists/artists/"),
    pjax: true
  },
  brands: {
    label: 'Brands',
    url: "".concat(PICSART_HOST_URL, "/brands/")
  },
  affiliates: {
    label: 'Affiliate Program',
    url: "".concat(PICSART_HOST_URL, "/affiliates/")
  },
  removeObjects: {
    label: 'Remove Objects',
    url: "".concat(PICSART_HOST_URL, "/remove-object-from-photo/")
  },
  canvasEffect: {
    label: 'Canvas Effect',
    url: "".concat(PICSART_HOST_URL, "/canvas-effect/")
  },
  brochureMaker: {
    label: 'Brochure Maker',
    url: "".concat(PICSART_HOST_URL, "/brochure-maker/")
  },
  invitationTemplates: {
    label: 'Invitation Templates',
    url: "".concat(PICSART_HOST_URL, "/design-templates/invitation/")
  },
  collageTemplates: {
    label: 'Collage Templates',
    url: "".concat(PICSART_HOST_URL, "/design-templates/collage/")
  },
  youtubeBannerMaker: {
    label: 'YouTube Banner Maker',
    url: "".concat(PICSART_HOST_URL, "/youtube-banner-maker/")
  },
  videoTrimmer: {
    label: 'Video Trimmer',
    url: "".concat(PICSART_HOST_URL, "/trim-video/")
  },
  replay: {
    label: 'Replay',
    url: "".concat(PICSART_HOST_URL, "/replay-image/")
  },
  addAudioToVideo: {
    label: 'Add Audio to Video',
    url: "".concat(PICSART_HOST_URL, "/add-music-to-video/")
  },
  resizeVideo: {
    label: 'Resize Video',
    url: "".concat(PICSART_HOST_URL, "/resize-video/")
  },
  styleTransfer: {
    label: 'Style Transfer',
    url: "".concat(PICSART_HOST_URL, "/style-transfer/")
  },
  cropImage: {
    label: 'Crop Image',
    url: "".concat(PICSART_HOST_URL, "/crop-image/")
  },
  resizeImage: {
    label: 'Resize Image',
    url: "".concat(PICSART_HOST_URL, "/resize-image/")
  },
  dripArt: {
    label: 'Drip Art',
    url: "".concat(PICSART_HOST_URL, "/drip-effect/")
  },
  templateEditor: {
    label: 'Template Editor',
    url: "".concat(PICSART_HOST_URL, "/design-templates/"),
    subCategory: 'template_editor',
    category: 'products'
  },
  memeTemplates: {
    label: 'Meme Templates',
    url: "".concat(PICSART_HOST_URL, "/design-templates/meme/")
  },
  flyerMaker: {
    label: 'Flyer Maker',
    url: "".concat(PICSART_HOST_URL, "/flyer-maker/")
  },
  flyerTemplates: {
    label: 'Flyer Templates',
    url: "".concat(PICSART_HOST_URL, "/design-templates/flyer/")
  },
  addTextToVideo: {
    label: 'Add Text to Video',
    url: "".concat(PICSART_HOST_URL, "/add-text-to-video/")
  },
  forDevelopers: {
    label: 'For Developers',
    url: 'https://picsart.io',
    subCategory: 'photo_editor',
    category: 'products'
  },
  quicktools: {
    label: 'Quicktools',
    url: 'https://tools.picsart.com'
  },
  businessSolutions: {
    label: 'Business Solutions',
    url: "".concat(PICSART_HOST_URL, "/business-solutions/"),
    subCategory: 'photo_editor',
    category: 'products'
  },
  forGoogleDrive: {
    label: 'For Google Drive',
    url: 'https://workspace.google.com/marketplace/app/picsart/228592224036',
    category: 'products'
  },
  aicpa: {
    label: '',
    url: 'https://pastatic.picsart.com/cms-pastatic/eeeee2a8-165c-4207-b273-edf9dd4a599f.pdf'
  },
  adMaker: {
    label: 'Admaker',
    url: 'https://onlineadmaker.com/'
  }
};

export { navigationItems as default };
//# sourceMappingURL=index.js.map
